export default __webpack_public_path__ + "static/media/Superunion_ligature_white_RGB.1b0d1eb3.png";